module.exports = __webpack_public_path__ + "static/media/vampire_armor.d2362084.png";